import React from 'react';

export function WrapColumnFormatter(cellContent) {
  return (
    <div className="text-dark-75 font-weight-bolder d-block font-size-lg">
      {cellContent}
    </div>
  );
}
